export default {
  /* Router */

  LOCATION_CHANGE_HANDLE: 'LOCATION_CHANGE_HANDLE',
  LOCATION_CHANGE_HANDLE__BOARD_FETCH: 'LOCATION_CHANGE_HANDLE__BOARD_FETCH',

  /* Socket */

  SOCKET_DISCONNECT_HANDLE: 'SOCKET_DISCONNECT_HANDLE',
  SOCKET_RECONNECT_HANDLE: 'SOCKET_RECONNECT_HANDLE',
  SOCKET_RECONNECT_HANDLE__CORE_FETCH: 'SOCKET_RECONNECT_HANDLE__CORE_FETCH',

  /* Login */

  FETCH_CORE_SETTINGS_PUBLIC: 'FETCH_CORE_SETTINGS_PUBLIC',
  AUTHENTICATE: 'AUTHENTICATE',
  AUTHENTICATE__SUCCESS: 'AUTHENTICATE__SUCCESS',
  AUTHENTICATE__FAILURE: 'AUTHENTICATE__FAILURE',
  AUTHENTICATE_ERROR_CLEAR: 'AUTHENTICATE_ERROR_CLEAR',
  AUTHENTICATE_SSO: 'AUTHENTICATE_SSO',
  AUTHENTICATE_SSO__SUCCESS: 'AUTHENTICATE_SSO__SUCCESS',
  AUTHENTICATE_SSO__FAILURE: 'AUTHENTICATE_SSO__FAILURE',
  REGISTER_OPEN: 'REGISTER_OPEN',
  LOGIN_OPEN: 'LOGIN_OPEN',
  REGISTER: 'REGISTER',
  REGISTER_ERROR_CLEAR: 'REGISTER_ERROR_CLEAR',
  REGISTER__SUCCESS: 'REGISTER__SUCCESS',
  REGISTER__FAILURE: 'REGISTER__FAILURE',

  /* Core */

  CORE_INITIALIZE: 'CORE_INITIALIZE',
  LOGOUT: 'LOGOUT',
  LOGOUT__ACCESS_TOKEN_INVALIDATE: 'LOGOUT__ACCESS_TOKEN_INVALIDATE',
  CORE_SETTINGS_UPDATE: 'CORE_SETTINGS_UPDATE',
  CORE_SETTINGS_UPDATE__SUCCESS: 'CORE_SETTINGS_UPDATE__SUCCESS',
  CORE_SETTINGS_UPDATE__FAILURE: 'CORE_SETTINGS_UPDATE__FAILURE',
  CORE_SETTINGS_UPDATE_HANDLE: 'CORE_SETTINGS_UPDATE_HANDLE',

  /* Api Clients */

  API_CLIENT_CREATE: 'API_CLIENT_CREATE',
  API_CLIENT_CREATE__SUCCESS: 'API_CLIENT_CREATE__SUCCESS',
  API_CLIENT_CREATE__FAILURE: 'API_CLIENT_CREATE__FAILURE',
  API_CLIENT_CREATE_HANDLE: 'API_CLIENT_CREATE_HANDLE',
  API_CLIENT_UPDATE: 'API_CLIENT_UPDATE',
  API_CLIENT_UPDATE__SUCCESS: 'API_CLIENT_UPDATE__SUCCESS',
  API_CLIENT_UPDATE__FAILURE: 'API_CLIENT_UPDATE__FAILURE',
  API_CLIENT_UPDATE_HANDLE: 'API_CLIENT_UPDATE_HANDLE',
  API_CLIENT_DELETE: 'API_CLIENT_DELETE',
  API_CLIENT_DELETE__SUCCESS: 'API_CLIENT_DELETE__SUCCESS',
  API_CLIENT_DELETE__FAILURE: 'API_CLIENT_DELETE__FAILURE',
  API_CLIENT_DELETE_HANDLE: 'API_CLIENT_DELETE_HANDLE',

  /* Modals */

  MODAL_OPEN: 'MODAL_OPEN',
  MODAL_CLOSE: 'MODAL_CLOSE',

  /* Users */

  USER_CREATE: 'USER_CREATE',
  USER_CREATE__SUCCESS: 'USER_CREATE__SUCCESS',
  USER_CREATE__FAILURE: 'USER_CREATE__FAILURE',
  USER_CREATE_HANDLE: 'USER_CREATE_HANDLE',
  USER_CREATE_ERROR_CLEAR: 'USER_CREATE_ERROR_CLEAR',
  USER_UPDATE: 'USER_UPDATE',
  USER_UPDATE__SUCCESS: 'USER_UPDATE__SUCCESS',
  USER_UPDATE__FAILURE: 'USER_UPDATE__FAILURE',
  USER_UPDATE_HANDLE: 'USER_UPDATE_HANDLE',
  USER_EMAIL_UPDATE: 'USER_EMAIL_UPDATE',
  USER_EMAIL_UPDATE__SUCCESS: 'USER_EMAIL_UPDATE__SUCCESS',
  USER_EMAIL_UPDATE__FAILURE: 'USER_EMAIL_UPDATE__FAILURE',
  USER_EMAIL_UPDATE_ERROR_CLEAR: 'USER_EMAIL_UPDATE_ERROR_CLEAR',
  USER_PASSWORD_UPDATE: 'USER_PASSWORD_UPDATE',
  USER_PASSWORD_UPDATE__SUCCESS: 'USER_PASSWORD_UPDATE__SUCCESS',
  USER_PASSWORD_UPDATE__FAILURE: 'USER_PASSWORD_UPDATE__FAILURE',
  USER_PASSWORD_UPDATE_ERROR_CLEAR: 'USER_PASSWORD_UPDATE_ERROR_CLEAR',
  USER_USERNAME_UPDATE: 'USER_USERNAME_UPDATE',
  USER_USERNAME_UPDATE__SUCCESS: 'USER_USERNAME_UPDATE__SUCCESS',
  USER_USERNAME_UPDATE__FAILURE: 'USER_USERNAME_UPDATE__FAILURE',
  USER_USERNAME_UPDATE_ERROR_CLEAR: 'USER_USERNAME_UPDATE_ERROR_CLEAR',
  USER_AVATAR_UPDATE: 'USER_AVATAR_UPDATE',
  USER_AVATAR_UPDATE__SUCCESS: 'USER_AVATAR_UPDATE__SUCCESS',
  USER_AVATAR_UPDATE__FAILURE: 'USER_AVATAR_UPDATE__FAILURE',
  USER_API_CLIENT_ERROR_CLEAR: 'USER_API_CLIENT_ERROR_CLEAR',
  USER_DELETE: 'USER_DELETE',
  USER_DELETE__SUCCESS: 'USER_DELETE__SUCCESS',
  USER_DELETE__FAILURE: 'USER_DELETE__FAILURE',
  USER_DELETE_HANDLE: 'USER_DELETE_HANDLE',
  USER_TO_CARD_ADD: 'USER_TO_CARD_ADD',
  USER_TO_CARD_ADD__SUCCESS: 'USER_TO_CARD_ADD__SUCCESS',
  USER_TO_CARD_ADD__FAILURE: 'USER_TO_CARD_ADD__FAILURE',
  USER_TO_CARD_ADD_HANDLE: 'USER_TO_CARD_ADD_HANDLE',
  USER_FROM_CARD_REMOVE: 'USER_FROM_CARD_REMOVE',
  USER_FROM_CARD_REMOVE__SUCCESS: 'USER_FROM_CARD_REMOVE__SUCCESS',
  USER_FROM_CARD_REMOVE__FAILURE: 'USER_FROM_CARD_REMOVE__FAILURE',
  USER_FROM_CARD_REMOVE_HANDLE: 'USER_FROM_CARD_REMOVE_HANDLE',
  USER_TO_TASK_ADD: 'USER_TO_TASK_ADD',
  USER_TO_TASK_ADD__SUCCESS: 'USER_TO_TASK_ADD__SUCCESS',
  USER_TO_TASK_ADD__FAILURE: 'USER_TO_TASK_ADD__FAILURE',
  USER_TO_TASK_ADD_HANDLE: 'USER_TO_TASK_ADD_HANDLE',
  USER_FROM_TASK_REMOVE: 'USER_FROM_TASK_REMOVE',
  USER_FROM_TASK_REMOVE__SUCCESS: 'USER_FROM_TASK_REMOVE__SUCCESS',
  USER_FROM_TASK_REMOVE__FAILURE: 'USER_FROM_TASK_REMOVE__FAILURE',
  USER_FROM_TASK_REMOVE_HANDLE: 'USER_FROM_TASK_REMOVE_HANDLE',
  USER_TO_BOARD_FILTER_ADD: 'USER_TO_BOARD_FILTER_ADD',
  USER_FROM_BOARD_FILTER_REMOVE: 'USER_FROM_BOARD_FILTER_REMOVE',
  USER_FILTER_QUERY_UPDATE: 'USER_FILTER_QUERY_UPDATE',
  USER_NOTIFICATION_FILTER_QUERY_UPDATE: 'USER_NOTIFICATION_FILTER_QUERY_UPDATE',

  /* User Prefs */

  USER_PREFS_UPDATE: `USER_PREFS_UPDATE`,
  USER_PREFS_UPDATE__SUCCESS: `USER_PREFS_UPDATE__SUCCESS`,
  USER_PREFS_UPDATE__FAILURE: `USER_PREFS_UPDATE__FAILURE`,
  USER_PREFS_UPDATE_HANDLE: `USER_PREFS_UPDATE_HANDLE`,

  /* Projects */

  PROJECT_CREATE: 'PROJECT_CREATE',
  PROJECT_CREATE__SUCCESS: 'PROJECT_CREATE__SUCCESS',
  PROJECT_CREATE__FAILURE: 'PROJECT_CREATE__FAILURE',
  PROJECT_CREATE_HANDLE: 'PROJECT_CREATE_HANDLE',
  PROJECT_UPDATE: 'PROJECT_UPDATE',
  PROJECT_UPDATE__SUCCESS: 'PROJECT_UPDATE__SUCCESS',
  PROJECT_UPDATE__FAILURE: 'PROJECT_UPDATE__FAILURE',
  PROJECT_UPDATE_HANDLE: 'PROJECT_UPDATE_HANDLE',
  PROJECT_BACKGROUND_IMAGE_UPDATE: 'PROJECT_BACKGROUND_IMAGE_UPDATE',
  PROJECT_BACKGROUND_IMAGE_UPDATE__SUCCESS: 'PROJECT_BACKGROUND_IMAGE_UPDATE__SUCCESS',
  PROJECT_BACKGROUND_IMAGE_UPDATE__FAILURE: 'PROJECT_BACKGROUND_IMAGE_UPDATE__FAILURE',
  PROJECT_DELETE: 'PROJECT_DELETE',
  PROJECT_DELETE__SUCCESS: 'PROJECT_DELETE__SUCCESS',
  PROJECT_DELETE__FAILURE: 'PROJECT_DELETE__FAILURE',
  PROJECT_DELETE_HANDLE: 'PROJECT_DELETE_HANDLE',
  PROJECT_IMPORT_GETTING_STARTED: 'PROJECT_IMPORT_GETTING_STARTED',
  PROJECT_IMPORT_GETTING_STARTED__SUCCESS: 'PROJECT_IMPORT_GETTING_STARTED__SUCCESS',
  PROJECT_IMPORT_GETTING_STARTED__FAILURE: 'PROJECT_IMPORT_GETTING_STARTED__FAILURE',

  /* Project Memberships */

  PROJECT_MEMBERSHIP_UPDATE: 'PROJECT_MEMBERSHIP_UPDATE',
  PROJECT_MEMBERSHIP_UPDATE__SUCCESS: 'PROJECT_MEMBERSHIP_UPDATE__SUCCESS',
  PROJECT_MEMBERSHIP_UPDATE__FAILURE: 'PROJECT_MEMBERSHIP_UPDATE__FAILURE',
  PROJECT_MEMBERSHIP_UPDATE_HANDLE: 'PROJECT_MEMBERSHIP_UPDATE_HANDLE',

  /* Project managers */

  PROJECT_MANAGER_CREATE: 'PROJECT_MANAGER_CREATE',
  PROJECT_MANAGER_CREATE__SUCCESS: 'PROJECT_MANAGER_CREATE__SUCCESS',
  PROJECT_MANAGER_CREATE__FAILURE: 'PROJECT_MANAGER_CREATE__FAILURE',
  PROJECT_MANAGER_CREATE_HANDLE: 'PROJECT_MANAGER_CREATE_HANDLE',
  PROJECT_MANAGER_CREATE_HANDLE__PROJECT_FETCH: 'PROJECT_MANAGER_CREATE_HANDLE__PROJECT_FETCH',
  PROJECT_MANAGER_DELETE: 'PROJECT_MANAGER_DELETE',
  PROJECT_MANAGER_DELETE__SUCCESS: 'PROJECT_MANAGER_DELETE__SUCCESS',
  PROJECT_MANAGER_DELETE__FAILURE: 'PROJECT_MANAGER_DELETE__FAILURE',
  PROJECT_MANAGER_DELETE_HANDLE: 'PROJECT_MANAGER_DELETE_HANDLE',

  /* Boards */

  BOARD_CREATE: 'BOARD_CREATE',
  BOARD_CREATE__SUCCESS: 'BOARD_CREATE__SUCCESS',
  BOARD_CREATE__FAILURE: 'BOARD_CREATE__FAILURE',
  BOARD_CREATE_HANDLE: 'BOARD_CREATE_HANDLE',
  BOARD_FETCH: 'BOARD_FETCH',
  BOARD_FETCH__SUCCESS: 'BOARD_FETCH__SUCCESS',
  BOARD_FETCH__FAILURE: 'BOARD_FETCH__FAILURE',
  BOARD_UPDATE: 'BOARD_UPDATE',
  BOARD_UPDATE__SUCCESS: 'BOARD_UPDATE__SUCCESS',
  BOARD_UPDATE__FAILURE: 'BOARD_UPDATE__FAILURE',
  BOARD_UPDATE_HANDLE: 'BOARD_UPDATE_HANDLE',
  BOARD_DELETE: 'BOARD_DELETE',
  BOARD_DELETE__SUCCESS: 'BOARD_DELETE__SUCCESS',
  BOARD_DELETE__FAILURE: 'BOARD_DELETE__FAILURE',
  BOARD_DELETE_HANDLE: 'BOARD_DELETE_HANDLE',
  BOARD_EXPORT: 'BOARD_EXPORT',
  BOARD_EXPORT__SUCCESS: 'BOARD_EXPORT__SUCCESS',
  BOARD_EXPORT__FAILURE: 'BOARD_EXPORT__FAILURE',
  BOARD_SEARCH_PARAMS_UPDATE: 'BOARD_SEARCH_PARAMS_UPDATE',

  /* Board memberships */

  BOARD_MEMBERSHIP_CREATE: 'BOARD_MEMBERSHIP_CREATE',
  BOARD_MEMBERSHIP_CREATE__SUCCESS: 'BOARD_MEMBERSHIP_CREATE__SUCCESS',
  BOARD_MEMBERSHIP_CREATE__FAILURE: 'BOARD_MEMBERSHIP_CREATE__FAILURE',
  BOARD_MEMBERSHIP_CREATE_HANDLE: 'BOARD_MEMBERSHIP_CREATE_HANDLE',
  BOARD_MEMBERSHIP_CREATE_HANDLE__PROJECT_FETCH: 'BOARD_MEMBERSHIP_CREATE_HANDLE__PROJECT_FETCH',
  BOARD_MEMBERSHIP_UPDATE: 'BOARD_MEMBERSHIP_UPDATE',
  BOARD_MEMBERSHIP_UPDATE__SUCCESS: 'BOARD_MEMBERSHIP_UPDATE__SUCCESS',
  BOARD_MEMBERSHIP_UPDATE__FAILURE: 'BOARD_MEMBERSHIP_UPDATE__FAILURE',
  BOARD_MEMBERSHIP_UPDATE_HANDLE: 'BOARD_MEMBERSHIP_UPDATE_HANDLE',
  BOARD_MEMBERSHIP_DELETE: 'BOARD_MEMBERSHIP_DELETE',
  BOARD_MEMBERSHIP_DELETE__SUCCESS: 'BOARD_MEMBERSHIP_DELETE__SUCCESS',
  BOARD_MEMBERSHIP_DELETE__FAILURE: 'BOARD_MEMBERSHIP_DELETE__FAILURE',
  BOARD_MEMBERSHIP_DELETE_HANDLE: 'BOARD_MEMBERSHIP_DELETE_HANDLE',

  /* Labels */

  LABEL_CREATE: 'LABEL_CREATE',
  LABEL_CREATE__SUCCESS: 'LABEL_CREATE__SUCCESS',
  LABEL_CREATE__FAILURE: 'LABEL_CREATE__FAILURE',
  LABEL_CREATE_HANDLE: 'LABEL_CREATE_HANDLE',
  LABEL_UPDATE: 'LABEL_UPDATE',
  LABEL_UPDATE__SUCCESS: 'LABEL_UPDATE__SUCCESS',
  LABEL_UPDATE__FAILURE: 'LABEL_UPDATE__FAILURE',
  LABEL_UPDATE_HANDLE: 'LABEL_UPDATE_HANDLE',
  LABEL_DELETE: 'LABEL_DELETE',
  LABEL_DELETE__SUCCESS: 'LABEL_DELETE__SUCCESS',
  LABEL_DELETE__FAILURE: 'LABEL_DELETE__FAILURE',
  LABEL_DELETE_HANDLE: 'LABEL_DELETE_HANDLE',
  LABEL_TO_CARD_ADD: 'LABEL_TO_CARD_ADD',
  LABEL_TO_CARD_ADD__SUCCESS: 'LABEL_TO_CARD_ADD__SUCCESS',
  LABEL_TO_CARD_ADD__FAILURE: 'LABEL_TO_CARD_ADD__FAILURE',
  LABEL_TO_CARD_ADD_HANDLE: 'LABEL_TO_CARD_ADD_HANDLE',
  LABEL_FROM_CARD_REMOVE: 'LABEL_FROM_CARD_REMOVE',
  LABEL_FROM_CARD_REMOVE__SUCCESS: 'LABEL_FROM_CARD_REMOVE__SUCCESS',
  LABEL_FROM_CARD_REMOVE__FAILURE: 'LABEL_FROM_CARD_REMOVE__FAILURE',
  LABEL_FROM_CARD_REMOVE_HANDLE: 'LABEL_FROM_CARD_REMOVE_HANDLE',
  LABEL_TO_BOARD_FILTER_ADD: 'LABEL_TO_BOARD_FILTER_ADD',
  LABEL_FROM_BOARD_FILTER_REMOVE: 'LABEL_FROM_BOARD_FILTER_REMOVE',

  /* Lists */

  LIST_CREATE: 'LIST_CREATE',
  LIST_CREATE__SUCCESS: 'LIST_CREATE__SUCCESS',
  LIST_CREATE__FAILURE: 'LIST_CREATE__FAILURE',
  LIST_CREATE_HANDLE: 'LIST_CREATE_HANDLE',
  LIST_UPDATE: 'LIST_UPDATE',
  LIST_UPDATE__SUCCESS: 'LIST_UPDATE__SUCCESS',
  LIST_UPDATE__FAILURE: 'LIST_UPDATE__FAILURE',
  LIST_UPDATE_HANDLE: 'LIST_UPDATE_HANDLE',
  LIST_DELETE: 'LIST_DELETE',
  LIST_DELETE__SUCCESS: 'LIST_DELETE__SUCCESS',
  LIST_DELETE__FAILURE: 'LIST_DELETE__FAILURE',
  LIST_DELETE_HANDLE: 'LIST_DELETE_HANDLE',

  /* Mails */

  MAIL_TOKEN_CREATE: 'MAIL_TOKEN_CREATE',
  MAIL_TOKEN_CREATE__SUCCESS: 'MAIL_TOKEN_CREATE__SUCCESS',
  MAIL_TOKEN_CREATE__FAILURE: 'MAIL_TOKEN_CREATE__FAILURE',
  MAIL_TOKEN_CREATE_HANDLE: 'MAIL_TOKEN_CREATE_HANDLE',
  MAIL_TOKEN_UPDATE: 'MAIL_TOKEN_UPDATE',
  MAIL_TOKEN_UPDATE__SUCCESS: 'MAIL_TOKEN_UPDATE__SUCCESS',
  MAIL_TOKEN_UPDATE__FAILURE: 'MAIL_TOKEN_UPDATE__FAILURE',
  MAIL_TOKEN_UPDATE_HANDLE: 'MAIL_TOKEN_UPDATE_HANDLE',
  MAIL_TOKEN_DELETE: 'MAIL_TOKEN_DELETE',
  MAIL_TOKEN_DELETE__SUCCESS: 'MAIL_TOKEN_DELETE__SUCCESS',
  MAIL_TOKEN_DELETE__FAILURE: 'MAIL_TOKEN_DELETE__FAILURE',
  MAIL_TOKEN_DELETE_HANDLE: 'MAIL_TOKEN_DELETE_HANDLE',

  /* Cards */

  CARD_CREATE: 'CARD_CREATE',
  CARD_CREATE__SUCCESS: 'CARD_CREATE__SUCCESS',
  CARD_CREATE__FAILURE: 'CARD_CREATE__FAILURE',
  CARD_CREATE_HANDLE: 'CARD_CREATE_HANDLE',
  CARD_FETCH: 'CARD_FETCH',
  CARD_FETCH__SUCCESS: 'CARD_FETCH__SUCCESS',
  CARD_FETCH__FAILURE: 'CARD_FETCH__FAILURE',
  CARD_UPDATE: 'CARD_UPDATE',
  CARD_UPDATE__SUCCESS: 'CARD_UPDATE__SUCCESS',
  CARD_UPDATE__FAILURE: 'CARD_UPDATE__FAILURE',
  CARD_UPDATE_HANDLE: 'CARD_UPDATE_HANDLE',
  CARD_DELETE: 'CARD_DELETE',
  CARD_DELETE__SUCCESS: 'CARD_DELETE__SUCCESS',
  CARD_DELETE__FAILURE: 'CARD_DELETE__FAILURE',
  CARD_DELETE_HANDLE: 'CARD_DELETE_HANDLE',
  CARD_DUPLICATE: 'CARD_DUPLICATE',
  CARD_DUPLICATE__SUCCESS: 'CARD_DUPLICATE__SUCCESS',
  CARD_DUPLICATE__FAILURE: 'CARD_DUPLICATE__FAILURE',
  CARD_DUPLICATE_HANDLE: 'CARD_DUPLICATE_HANDLE',

  /* Tasks */

  TASK_CREATE: 'TASK_CREATE',
  TASK_CREATE__SUCCESS: 'TASK_CREATE__SUCCESS',
  TASK_CREATE__FAILURE: 'TASK_CREATE__FAILURE',
  TASK_CREATE_HANDLE: 'TASK_CREATE_HANDLE',
  TASK_UPDATE: 'TASK_UPDATE',
  TASK_UPDATE__SUCCESS: 'TASK_UPDATE__SUCCESS',
  TASK_UPDATE__FAILURE: 'TASK_UPDATE__FAILURE',
  TASK_UPDATE_HANDLE: 'TASK_UPDATE_HANDLE',
  TASK_DUPLICATE: 'TASK_DUPLICATE',
  TASK_DUPLICATE__SUCCESS: 'TASK_DUPLICATE__SUCCESS',
  TASK_DUPLICATE__FAILURE: 'TASK_DUPLICATE__FAILURE',
  TASK_DUPLICATE_HANDLE: 'TASK_DUPLICATE_HANDLE',
  TASK_DELETE: 'TASK_DELETE',
  TASK_DELETE__SUCCESS: 'TASK_DELETE__SUCCESS',
  TASK_DELETE__FAILURE: 'TASK_DELETE__FAILURE',
  TASK_DELETE_HANDLE: 'TASK_DELETE_HANDLE',

  /* Attachments */

  ATTACHMENT_CREATE: 'ATTACHMENT_CREATE',
  ATTACHMENT_CREATE__SUCCESS: 'ATTACHMENT_CREATE__SUCCESS',
  ATTACHMENT_CREATE__FAILURE: 'ATTACHMENT_CREATE__FAILURE',
  ATTACHMENT_CREATE_HANDLE: 'ATTACHMENT_CREATE_HANDLE',
  ATTACHMENT_UPDATE: 'ATTACHMENT_UPDATE',
  ATTACHMENT_UPDATE__SUCCESS: 'ATTACHMENT_UPDATE__SUCCESS',
  ATTACHMENT_UPDATE__FAILURE: 'ATTACHMENT_UPDATE__FAILURE',
  ATTACHMENT_UPDATE_HANDLE: 'ATTACHMENT_UPDATE_HANDLE',
  ATTACHMENT_DELETE: 'ATTACHMENT_DELETE',
  ATTACHMENT_DELETE__SUCCESS: 'ATTACHMENT_DELETE__SUCCESS',
  ATTACHMENT_DELETE__FAILURE: 'ATTACHMENT_DELETE__FAILURE',
  ATTACHMENT_DELETE_HANDLE: 'ATTACHMENT_DELETE_HANDLE',

  /* Activities */

  ACTIVITIES_ATTACHMENT_FETCH: 'ACTIVITIES_ATTACHMENT_FETCH',
  ACTIVITIES_ATTACHMENT_FETCH__SUCCESS: 'ACTIVITIES_ATTACHMENT_FETCH__SUCCESS',
  ACTIVITIES_ATTACHMENT_FETCH__FAILURE: 'ACTIVITIES_ATTACHMENT_FETCH__FAILURE',
  ACTIVITIES_COMMENT_FETCH: 'ACTIVITIES_COMMENT_FETCH',
  ACTIVITIES_COMMENT_FETCH__SUCCESS: 'ACTIVITIES_COMMENT_FETCH__SUCCESS',
  ACTIVITIES_COMMENT_FETCH__FAILURE: 'ACTIVITIES_COMMENT_FETCH__FAILURE',
  ACTIVITIES_TASK_FETCH: 'ACTIVITIES_TASK_FETCH',
  ACTIVITIES_TASK_FETCH__SUCCESS: 'ACTIVITIES_TASK_FETCH__SUCCESS',
  ACTIVITIES_TASK_FETCH__FAILURE: 'ACTIVITIES_TASK_FETCH__FAILURE',
  ACTIVITIES_CARD_FETCH: 'ACTIVITIES_CARD_FETCH',
  ACTIVITIES_CARD_FETCH__SUCCESS: 'ACTIVITIES_CARD_FETCH__SUCCESS',
  ACTIVITIES_CARD_FETCH__FAILURE: 'ACTIVITIES_CARD_FETCH__FAILURE',
  ACTIVITIES_LIST_FETCH: 'ACTIVITIES_LIST_FETCH',
  ACTIVITIES_LIST_FETCH__SUCCESS: 'ACTIVITIES_LIST_FETCH__SUCCESS',
  ACTIVITIES_LIST_FETCH__FAILURE: 'ACTIVITIES_LIST_FETCH__FAILURE',
  ACTIVITIES_BOARD_FETCH: 'ACTIVITIES_BOARD_FETCH',
  ACTIVITIES_BOARD_FETCH__SUCCESS: 'ACTIVITIES_BOARD_FETCH__SUCCESS',
  ACTIVITIES_BOARD_FETCH__FAILURE: 'ACTIVITIES_BOARD_FETCH__FAILURE',
  ACTIVITIES_PROJECT_FETCH: 'ACTIVITIES_PROJECT_FETCH',
  ACTIVITIES_PROJECT_FETCH__SUCCESS: 'ACTIVITIES_PROJECT_FETCH__SUCCESS',
  ACTIVITIES_PROJECT_FETCH__FAILURE: 'ACTIVITIES_PROJECT_FETCH__FAILURE',
  ACTIVITIES_USER_FETCH: 'ACTIVITIES_USER_FETCH',
  ACTIVITIES_USER_FETCH__SUCCESS: 'ACTIVITIES_USER_FETCH__SUCCESS',
  ACTIVITIES_USER_FETCH__FAILURE: 'ACTIVITIES_USER_FETCH__FAILURE',
  ACTIVITIES_USER_ACCOUNT_FETCH: 'ACTIVITIES_USER_ACCOUNT_FETCH',
  ACTIVITIES_USER_ACCOUNT_FETCH__SUCCESS: 'ACTIVITIES_USER_ACCOUNT_FETCH__SUCCESS',
  ACTIVITIES_USER_ACCOUNT_FETCH__FAILURE: 'ACTIVITIES_USER_ACCOUNT_FETCH__FAILURE',
  ACTIVITIES_INSTANCE_FETCH: 'ACTIVITIES_INSTANCE_FETCH',
  ACTIVITIES_INSTANCE_FETCH__SUCCESS: 'ACTIVITIES_INSTANCE_FETCH__SUCCESS',
  ACTIVITIES_INSTANCE_FETCH__FAILURE: 'ACTIVITIES_INSTANCE_FETCH__FAILURE',
  ACTIVITY_CREATE_HANDLE: 'ACTIVITY_CREATE_HANDLE',

  /* Comments */

  COMMENTS_IN_CARD_FETCH: 'COMMENTS_IN_CARD_FETCH',
  COMMENTS_IN_CARD_FETCH__SUCCESS: 'COMMENTS_IN_CARD_FETCH__SUCCESS',
  COMMENTS_IN_CARD_FETCH__FAILURE: 'COMMENTS_IN_CARD_FETCH__FAILURE',
  COMMENT_CREATE: 'COMMENT_CREATE',
  COMMENT_CREATE__SUCCESS: 'COMMENT_CREATE__SUCCESS',
  COMMENT_CREATE__FAILURE: 'COMMENT_CREATE__FAILURE',
  COMMENT_UPDATE: 'COMMENT_UPDATE',
  COMMENT_UPDATE__SUCCESS: 'COMMENT_UPDATE__SUCCESS',
  COMMENT_UPDATE__FAILURE: 'COMMENT_UPDATE__FAILURE',
  COMMENT_DELETE: 'COMMENT_DELETE',
  COMMENT_DELETE__SUCCESS: 'COMMENT_DELETE__SUCCESS',
  COMMENT_DELETE__FAILURE: 'COMMENT_DELETE__FAILURE',
  COMMENT_CREATE_HANDLE: 'COMMENT_CREATE_HANDLE',
  COMMENT_UPDATE_HANDLE: 'COMMENT_UPDATE_HANDLE',
  COMMENT_DELETE_HANDLE: 'COMMENT_DELETE_HANDLE',

  /* Notifications */

  NOTIFICATION_CREATE_HANDLE: 'NOTIFICATION_CREATE_HANDLE',
  NOTIFICATION_UPDATE: 'NOTIFICATION_UPDATE',
  NOTIFICATION_UPDATE__SUCCESS: 'NOTIFICATION_UPDATE__SUCCESS',
  NOTIFICATION_UPDATE__FAILURE: 'NOTIFICATION_UPDATE__FAILURE',
  NOTIFICATION_UPDATE_HANDLE: 'NOTIFICATION_UPDATE_HANDLE',
  NOTIFICATION_MARK_ALL_AS: 'NOTIFICATION_MARK_ALL_AS',
  NOTIFICATION_MARK_ALL_AS__SUCCESS: 'NOTIFICATION_MARK_ALL_AS__SUCCESS',
  NOTIFICATION_MARK_ALL_AS__FAILURE: 'NOTIFICATION_MARK_ALL_AS__FAILURE',
  NOTIFICATION_MARK_ALL_AS_HANDLE: 'NOTIFICATION_MARK_ALL_AS_HANDLE',
  NOTIFICATION_DELETE: 'NOTIFICATION_DELETE',
  NOTIFICATION_DELETE__SUCCESS: 'NOTIFICATION_DELETE__SUCCESS',
  NOTIFICATION_DELETE__FAILURE: 'NOTIFICATION_DELETE__FAILURE',
  NOTIFICATION_DELETE_HANDLE: 'NOTIFICATION_DELETE_HANDLE',
  NOTIFICATION_DELETE_ALL: 'NOTIFICATION_DELETE_ALL',
  NOTIFICATION_DELETE_ALL__SUCCESS: 'NOTIFICATION_DELETE_ALL__SUCCESS',
  NOTIFICATION_DELETE_ALL__FAILURE: 'NOTIFICATION_DELETE_ALL__FAILURE',
  NOTIFICATION_DELETE_ALL_HANDLE: 'NOTIFICATION_DELETE_ALL_HANDLE',
};
